export default __webpack_public_path__ + "static/media/Mockup4.7310424a.png";